import { lazy } from 'react';

const TimeSheetCalendar = lazy(() => import('./TimeSheetCalendar'));

export default TimeSheetCalendar;
